import { Injectable } from '@angular/core';
import { Configuration } from 'src/app/shared/models/configuration.model';
import { AuthConfig } from 'angular-oauth2-oidc';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MaxCacheTime } from 'projects/dop-core/src/public-api';
import { Observable, of } from 'rxjs';
import { MatomoConfig } from 'src/app/shared/models/matomo.config.model';

@Injectable()
export class AppConfigService {

    authConfig: AuthConfig;
    configuration: Configuration;
    configuration$: Observable<Configuration> = new Observable<Configuration>();
    matomoConfig: MatomoConfig;

    constructor(private http: HttpClient) { }

    async setConfiguration(): Promise<Configuration> {
        return new Promise((resolve, reject) => {
            const path = environment.configurationPath;
            this.http.get(path).toPromise().then((response: any) => {
                this.configuration = response;
                this.configuration$ = of(this.configuration);
                this.configuration.apiConfig.eolctQueryBaseUrl = this.configuration.apiConfig.eolctQueryBaseUrl + 'v2/';
                MaxCacheTime.time = this.configuration.maxCacheTime;
                this.matomoConfig = response.matomoConfig;
                return resolve(this.configuration);
            }).then(() => resolve())
                .catch(() => reject());
        });
    }

    getMatomoConfig(): MatomoConfig {
        return this.matomoConfig;
    }

    get EolWebsiteUrl(): string {
        return this.configuration.eolWebsiteUrl;
    }
}
